<template>
  <canvas ref="bars" :class="name"></canvas>
</template>

<script>
import randomBytes from 'random-bytes'
import { mapGetters } from 'vuex'
export default {
  props: {
    width: {
      type: Number,
      default() {
        return 300
      },
    },
    height: {
      type: Number,
      default() {
        return 150
      },
    },
  },
  data() {
    return {
      name: 'a-canvas-bars',
      ctx: null,
      id: undefined,
      framesPerSecond: 60,
      timer: null,
      TRI_COLORS: ['#D1CCC4', '#C33CA8', '#7A7A78'],
      COLORS: [
        '#000000',
        '#0000D7',
        '#0000FF',
        '#D70000',
        '#FF0000',
        '#D700D7',
        '#FF00FF',
        '#00D700',
        '#00FF00',
        '#00D7D7',
        '#00FFFF',
        '#D7D700',
        '#FFFF00',
        '#D7D7D7',
        '#FFFFFF',
      ],
    }
  },
  computed: {
    ...mapGetters({
      loading: 'loading/isLoading',
    }),
  },
  mounted() {
    this.ctx = this.$refs.bars.getContext('2d')
    this.fitToContainer()
    this.setColor()
    this.timeout = setTimeout(() => {
      this.update()
    }, 400)
  },
  destroyed() {
    window.cancelAnimationFrame(this.id)
    window.clearTimeout(this.timeout)
    this.timeout = undefined
    this.id = undefined
  },
  methods: {
    fitToContainer() {
      // ...then set the internal size to match
      this.ctx.width = this.width
      this.ctx.height = this.height
    },
    update() {
      this.id = requestAnimationFrame(this.update)
      randomBytes(4, (error, bytes) => {
        if (error) throw error
        this.draw(bytes)
      })
    },
    setColor() {
      this.fg = this.TRI_COLORS[Math.floor(Math.random() * Math.floor(3))]
    },
    draw(bytes) {
      const { ctx, fg } = this
      const data = new Uint8Array(bytes.length * 8)
      const width = this.width
      const height = this.height

      this.setColor()

      for (let i = 0; i < bytes.length; i++) {
        const binary = bytes[i].toString(2).padStart(8, '0').split('')

        for (let j = 0; j < binary.length; j++) {
          data[i * 8 + j] = binary[j] === '1' ? 1 : 0
        }
      }

      const length = data.length
      ctx.fillStyle = fg

      ctx.lineWidth = 1
      ctx.strokeStyle = 'rgb(0, 0, 0)'

      ctx.clearRect(0, 0, width, height)
      ctx.beginPath()
      const slice = (ctx.height / length + 0.5) | 0
      let y = 0

      for (let i = 0; i < length; i++) {
        if (data[i] === 1) {
          ctx.rect(-1, y, width + 2, slice)
        }
        y += slice
      }

      ctx.fill()
    },
  },
}
</script>

<style lang="scss" scoped>
.a-canvas-bars {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 125px;
  height: 125px;
}
</style>
